import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row, InputGroup } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { useToast } from 'context/providers/ToastProvider';

/**
 * Componente para la sección de Datos Fiscales del Emisor y Cliente
 * Soporta caracteres Unicode (acentos, ñ, símbolos especiales)
 */
const DatosFiscalesReceptorFactura = ({
    cargandoForm,
    errors,
    clearError,

    // Props de datos fiscales del cliente
    register,
    selectedValues,
    setSelectedValues,
    isForeignRFC,
    handleRFCChange,
    setValue
}) => {
    const { token, setToken } = useToken();

    const [regimenesFiscales, setRegimenesFiscales] = useState([])
    const [paises, setPaises] = useState([]);
    const [usoCFDI, setUsoCFDI] = useState([]);
    const { showErrorToast } = useToast();
    /**
     * Obtiene los Regimenes Fiscales
     */
    const ObtenerRegimenesFiscales = async () => {

        const response = await fetch("/api/contabilidad/CatalogoSAT/ObtenerRegimenesFiscales",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                // console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            // console.log("==== OBTENER REGIMENES FISCALES ====");

            // console.log("response: ", response);
            const data = await response.json();
            // console.log("dataRF: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                //   console.log("ObjDetallesRF:", ObjDetalles);

                setRegimenesFiscales(ObjDetalles.table2);


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    }

    /**
    * Obtiene Uso CFDI
    */
    const ObtenerUsoCFDI = async () => {

        const response = await fetch("/api/contabilidad/CatalogoSAT/ObtenerUsoCFDI",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                //console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            //console.log("==== OBTENER USO CFDI ====");

            //console.log("response: ", response);
            const data = await response.json();
            // console.log("dataRF: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                //console.log("ObjDetallesCFDI:", ObjDetalles);

                setUsoCFDI(ObjDetalles.table2);


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    }

    /**
   * Obtiene los paises del Cat Sat
   */
    const ObtenerCatPaises = async () => {
        if (paises.length > 0) return; // Ya están cargadas

        const response = await fetch("/api/contabilidad/CatalogoSAT/ObtenerCatPaises",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                //console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            //console.log("==== OBTENER PAIS ====");

            //console.log("response: ", response);
            const data = await response.json();
            //console.log("dataRF: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                //console.log("ObjDetallesPais:", ObjDetalles);

                setPaises(ObjDetalles.table2);


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    }


    useEffect(() => {
        ObtenerRegimenesFiscales();
        ObtenerUsoCFDI();
        ObtenerCatPaises();
    }, []);

    return (
        <>
            <h5 className="seccion-titulo mt-3 mb-3 bg-light p-2 rounded text-dark">Datos Fiscales del Receptor</h5>
            <Row className="mb-1">
                <Col xs={12} className="mb-2">
                    {/* Razn Social */}
                    <Form.Group>
                        <Form.Label className="form-label-profesional">Raz&oacute;n Social</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                : <Form.Control className="form-control-profesional" size="sm"
                                    autoComplete="off"
                                    type="text"
                                    defaultValue=""
                                    onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                    isInvalid={!!errors.vRazonSocial}
                                    {...register('vRazonSocial',
                                        {
                                            required: 'La Raz\u00f3n Social es obligatoria',
                                            maxLength: 300,
                                            minLength: 1,
                                            pattern: /[^|]{1,300}/
                                        })
                                    }
                                    onChange={(e) => {
                                        if (e.target.value) {
                                            clearError("vRazonSocial");
                                        }
                                    }}
                                />
                        }
                        {errors.vRazonSocial && (
                            <Form.Text className="form-error-text">{errors.vRazonSocial}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-1">
                <Col xs={12} md={6} className="mb-2">
                    {/* RFC */}
                    <Form.Group>
                        <Form.Label className="form-label-profesional">
                            RFC
                        </Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <InputGroup size="sm">
                                    <Form.Control className="form-control-profesional"
                                        type="text"
                                        autoComplete="off"
                                        {...register("vRFC", {
                                            pattern: {
                                                value: /^[A-Z&]{3,4}\d{6}(?:[A-Z\d]{3})?$/,
                                                message: "El RFC no tiene un formato v\u00e1lido",
                                            },
                                        })}
                                        onChange={(e) => {
                                            handleRFCChange(e.target.value)
                                            if (e.target.value) {
                                                clearError("vRFC");
                                            }
                                        }}
                                        isInvalid={!!errors.vRFC}
                                    />
                                    {!isForeignRFC && (
                                        <InputGroup.Text style={{ padding: '0 8px', backgroundColor: '#fff', borderLeft: 'none' }}>
                                            <img src="/img/bandera-mexico-48.png" alt="México" style={{ height: '14px' }} />
                                        </InputGroup.Text>
                                    )}
                                </InputGroup>
                        }
                        {errors.vRFC && (
                            <Form.Text className="form-error-text">{errors.vRFC}</Form.Text>
                        )}
                    </Form.Group>
                </Col>

                <Col xs={12} md={6} className="mb-2">
                    <Form.Group>
                        <Form.Label className="form-label-profesional">C&oacute;digo Postal</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Control className="form-control-profesional" size="sm"
                                    type="text"
                                    inputMode="numeric"
                                    autoComplete="off"
                                    maxLength={5}
                                    {...register("vCP", {
                                        required: "El c\u00f3digo postal es obligatorio",
                                        pattern: { value: /^\d{5}$/, message: "Formato no v\u00e1lido (5 d\u00edgitos)" },
                                    })}
                                    onChange={(e) => {
                                        let valor = e.target.value.replace(/\D/g, ""); // Elimina caracteres no numéricos
                                        setValue("vCP", valor);
                                        if (valor) {
                                            clearError("vCP"); // Limpia errores si se ingresa algo
                                        }
                                    }}
                                    onBlur={(e) => {
                                        let valorIngresado = e.target.value.trim();
                                        if (valorIngresado === register("vCP").value) {
                                            return;
                                        }
                                        clearError("vCP");
                                    }}
                                    isInvalid={!!errors.vCP}
                                />
                        }
                        {errors.vCP && (
                            <Form.Text className="form-error-text">{errors.vCP}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-1">
                <Col xs={12} className="mb-2">
                    {/* Régimen Fiscal */}
                    <Form.Group>
                        <Form.Label className="form-label-profesional">R&eacute;gimen Fiscal</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Select className="form-control-profesional" size="sm"
                                    isInvalid={!!errors.vCodigoRegimen}
                                    value={selectedValues.vCodigoRegimen || ""}
                                    onChange={(e) => {
                                        setSelectedValues((prev) => ({ ...prev, vCodigoRegimen: e.target.value }));
                                        if (e.target.value) {
                                            clearError("vCodigoRegimen");
                                        }
                                    }}                            >
                                    <option value="">Selecciona un r&eacute;gimen</option>
                                    {regimenesFiscales.map((regimen, index) => (
                                        <option key={index} value={regimen.vCodigoRegimen}>
                                            {regimen.vCodigoRegimen} - {regimen.vDescripcionRegimenFiscal}
                                        </option>
                                    ))}
                                </Form.Select>
                        }
                        {errors.vCodigoRegimen && (
                            <Form.Text className="form-error-text">{errors.vCodigoRegimen}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-1">
                <Col xs={12} md={6} className="mb-2">
                    <Form.Group>
                        <Form.Label className="form-label-profesional">Uso CFDI</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Select className="form-control-profesional" size="sm"
                                    value={selectedValues.vCodigoUso || ""}
                                    onChange={(e) => {
                                        setSelectedValues((prev) => ({ ...prev, vCodigoUso: e.target.value }));
                                        if (e.target.value) {
                                            clearError("vCodigoUso");
                                        }
                                    }}
                                    isInvalid={!!errors.vCodigoUso}
                                >
                                    <option value="">Seleccione un Uso CFDI</option>
                                    {usoCFDI.map((cfdi, index) => (
                                        <option key={index} value={cfdi.vCodigoUso}>
                                            {cfdi.vCodigoUso} - {cfdi.vDescripcionUsoCFDI}
                                        </option>
                                    ))}
                                </Form.Select>
                        }
                        {errors.vCodigoUso && (
                            <Form.Text className="form-error-text">{errors.vCodigoUso}</Form.Text>
                        )}
                    </Form.Group>
                </Col>

                <Col xs={12} md={6} className="mb-2">
                    <Form.Group>
                        <Form.Label className="form-label-profesional">Email</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Control className="form-control-profesional" size="sm"
                                    type="email"
                                    autoComplete="off"
                                    isInvalid={!!errors.vEmail}
                                    {...register("vEmail", {
                                        pattern: {
                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                            message: "Formato de correo no v\u00e1lido",
                                        },
                                    })}
                                />
                        }
                        {errors.vEmail && (
                            <Form.Text className="form-error-text">{errors.vEmail}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            {/* Campos adicionales para RFC extranjero */}
            {isForeignRFC && (
                <Row className="mb-1">
                    <Col xs={12} md={6} className="mb-2">
                        <Form.Group>
                            <Form.Label className="form-label-profesional">Pa&iacute;s de Residencia</Form.Label>
                            {
                                cargandoForm ?
                                    <Skeleton />
                                    :
                                    <Form.Select className="form-control-profesional" size="sm"
                                        {...register("vPaisFacturacion", { required: isForeignRFC ? "El país es requerido" : false })}
                                        onChange={(e) => {
                                            setValue("vPaisFacturacion", e.target.value);
                                            setSelectedValues((prev) => ({ ...prev, vPaisFacturacion: e.target.value }));
                                            if (e.target.value) {
                                                clearError("vPaisFacturacion");
                                            }
                                        }}
                                        value={selectedValues.vPaisFacturacion}
                                        isInvalid={!!errors.vPaisFacturacion}
                                    >
                                        <option value="">Seleccione un Pa&iacute;s</option>
                                        {paises.map((name, index) => (
                                            <option key={index} value={name.cShortName}>
                                                {name.cShortName} - {name.vName}
                                            </option>
                                        ))}
                                    </Form.Select>
                            }
                            {errors.vPaisFacturacion && (
                                <Form.Text className="form-error-text">{errors.vPaisFacturacion}</Form.Text>
                            )}
                        </Form.Group>
                    </Col>

                    <Col xs={12} md={6} className="mb-2">
                        <Form.Group>
                            <Form.Label className="form-label-profesional">N&uacute;m. Registro Tributario</Form.Label>
                            {
                                cargandoForm ?
                                    <Skeleton />
                                    :
                                    <Form.Control className="form-control-profesional" size="sm"
                                        type="text"
                                        {...register("vNumRT", {
                                            maxLength: { value: 20, message: "El NumRT no puede superar los 20 caracteres" },
                                        })}
                                        onChange={(e) => {
                                            if (e.target.value) {
                                                clearError("vNumRT");
                                            }
                                        }}
                                        isInvalid={!!errors.vNumRT}
                                    />
                            }
                            {errors.vNumRT && (
                                <Form.Text className="form-error-text">{errors.vNumRT}</Form.Text>
                            )}
                        </Form.Group>
                    </Col>
                </Row>
            )}
        </>
    );
};

DatosFiscalesReceptorFactura.propTypes = {
    // Props del emisor
    cargandoForm: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    clearError: PropTypes.func.isRequired,

    // Props de datos fiscales del cliente
    register: PropTypes.func.isRequired,
    selectedValues: PropTypes.object.isRequired,
    setSelectedValues: PropTypes.func.isRequired,
    isForeignRFC: PropTypes.bool.isRequired,
    handleRFCChange: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired
};

export default DatosFiscalesReceptorFactura;

